import React from 'react'
import Lang from 'Lang/General'
import LoadingOverlay from 'components/Indicator/LoadingOverlay'
import _ from 'lodash'
import { useEffect } from 'react'
import {
  Button,
  Card, CardBody, CardHeader,
  Input
} from 'reactstrap'
import HOC from './actions/index'
import ProgrammeForm from './Form'

function Speaker(props) {

  useEffect(() => {
    props.getFairs()
    props.getStages()
  }, [])

  useEffect(() => {
    if (!_.isEmpty(props.selectedPortalUsers)) {
      props.getProgramme({
        filter: { "user_id": props.selectedPortalUsers.id },
        page: 1,
        is_paginated: false,
      })
    }
  }, [props.selectedPortalUsers])

  useEffect(() => {
    if (props.programmes?.[0]) {
      props.onChangeProgrammeHOC('selectedProgramme', props.programmes?.[0])
    }
  }, [props.programmes])


  return (
    <>
      <div className="d-flex">
        <Button
          className={'ml-auto mr-2'}
          color={'primary'}
          onClick={() => {
            props.onChangeProgrammeHOC('selectedProgramme', '')
          }}
        >
          {Lang['CREATE_SPEAKER'][props.data.languageReducer.userSettings.admin_panel_language]}
        </Button>
        <Input
          value={props.selectedProgramme?.id || ''}
          type={'select'}
          style={{ maxWidth: 150 }}
          placeholder={'Select Speaker'}
          onChange={e => props.onChangeProgrammeHOC('selectedProgramme', _.find(props.programmes, { id: +e.target.value }))}
        >
          <option value={''}>
            {''}
          </option>
          {
            props.programmes.map(speakerOption => (
              <option key={speakerOption.id} value={speakerOption.id}>
                {`${speakerOption.first_name} ${speakerOption.last_name}`}
              </option>
            ))
          }
        </Input>
      </div>
      <Card className={'mt-4 mb-2'}>
        <CardHeader>
          {
            Lang[!props.selectedProgramme ? 'CREATE_SPEAKER' : 'UPDATE_SPEAKER'][props.data.languageReducer.userSettings.admin_panel_language]
          }
        </CardHeader>
        <CardBody>
          <ProgrammeForm
            clientID={props.data.selectCenterReducer.selectedCenter.center.client_id}
            data={props.data}
            fairs={props.fairs}
            selectedPortalUsers={props.selectedPortalUsers}
            stages={props.stages}
            selectedProgramme={props.selectedProgramme}
            mode={!props.selectedProgramme ? 'create' : 'edit'}
            onSubmit={val => {
              !props.selectedProgramme
                ? props.createProgramme(val)
                : props.updateProgramme(val)
            }}
          />
        </CardBody>
      </Card>
      {
        props.onLoadSpeaker && <LoadingOverlay />
      }
    </>
  )
}

export default HOC(Speaker)